<template>
  <WistiaMovie asset="jmfdsuq0sg" :autoplay="autoplay">
    <b-btn>Watch movie&nbsp;<i class="far fa-play-circle"/></b-btn>
  </WistiaMovie>
</template>

<style lang="scss" scoped>
.btn {
  background: #55BAEA;
  border: none;
  @media (max-width: 575.98px) {
    background: none;
    color: #666;
    width: auto;
  }
}
</style>




<script>
export default {
  computed: {
    autoplay() {
      return !!this.$route.query.openvideo;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/shared/HowItWorksButton.vue